/// <reference path="../../Common/Helpers/GridEditorBase.ts" />


namespace Matrix.Indexation {

    @Serenity.Decorators.registerEditor("Matrix.Indexation.BasketConstituentsEditor")
    export class BasketConstituentsEditor extends Common.GridEditorBase<BasketConstituentRow> {
        protected getColumnsKey() { return BasketConstituentColumns.columnsKey; }
        protected getDialogType() { return BasketConstituentsEditorDialog; }
        protected getIdProperty() { return BasketConstituentRow.idProperty; }
        protected getInsertPermission() { return BasketConstituentRow.insertPermission; }
        protected getLocalTextPrefix() { return BasketConstituentRow.localTextPrefix; }

        constructor(container: JQuery) {
            super(container);
        }

        protected updateInterface() {
            super.updateInterface();

            this.toolbar.findButton('add-button').toggleClass('disabled', !!this.readOnly);
        }

        public indexCode: string;

        protected validateEntity(entity: BasketConstituentRow, id: number) {
            if (!super.validateEntity(entity, id))
                return false;

            if (this.indexCode &&
                entity.ConstituentIndexCode == this.indexCode) {
                Q.notifyError("You can't add the index itself as part of its basket constituents!");
                return false;
            }

            return true;
        }

        protected setEntities(items) {
            if (Math.abs(items.reduce((prev, curr) => prev + curr.Weight, 0) - 1) >= 0.0000001 ) {
                Q.notifyWarning("Basket constituents doesn't sum to 1!")
            }

            super.setEntities(items);
        }
    }
}